import axios from "axios";
import { useState } from "react";
import Popup from "reactjs-popup";
import { mobile } from "../data/categories";
import "./ImageFullSize.css";
import Spinner from "./Spinner";

const ImageFullSize = ({ path, title, category }) => {
  const [isLoading, setisLoading] = useState(true);

  async function fetchImage() {
    await axios.get(path);
    setisLoading(false);
  }

  fetchImage();
  if (isLoading) {
    return (
      <Popup
        trigger={
          <div className="absolute left-0 top-0  h-full w-full cursor-pointer"></div>
        }
        modal
        position="center center"
        nested
      >
        {(close) => (
          <div className="top-10 left-0 mx-4 max-h-full">
            <div className="bg-gray-200 flex flex-col justify-between h-full mx-auto relative p-3">
              <span
                className="bg-white shadow-md px-2 text-2xl rounded-full m-3 absolute -right-5 -top-5 cursor-pointer"
                onClick={() => {
                  // console.log("modal closed ");
                  close();
                }}
              >
                &times;
              </span>
              <div className="w-100">
                <Spinner />
              </div>
              
            </div>
          </div>
        )}
      </Popup>
    );
  } else {
    return (
      <Popup
        trigger={
          <div className="absolute left-0 top-0  h-full w-full cursor-pointer"></div>
        }
        modal
        position="center center"
        nested
      >
        {(close) => (
          <div className="top-10 left-0 mx-4 max-h-full">
            <div className="bg-gray-200 flex flex-col justify-between h-full mx-auto relative p-3">
              <span
                className="bg-white shadow-md px-2 text-2xl rounded-full m-3 absolute -right-5 -top-5 cursor-pointer"
                onClick={() => {
                  // console.log("modal closed ");
                  close();
                }}
              >
                &times;
              </span>
              <h3 className="flex-auto">{title}</h3>
              <img
                width={category === mobile ? "400" : "100%"}
                src={path}
                alt={title}
              />
            </div>
          </div>
        )}
      </Popup>
    );
  }
};

export default ImageFullSize;
